import { graphql, Environment, fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';
import { getBuyerId } from 'dibs-cookie-jar';
import { FC } from 'react';
import { addLoginHandlers } from '../../exports/loginHandlers';

import FooterTrackingWrapper from './Footer/FooterTrackingWrapper';
import FooterSeoLinkWrapper from './Footer/FooterSeoLinkWrapper';
import Contact1stdibsFooterLinkWrapper from './Contact1stdibsLink/Contact1stdibsFooterLinkWrapper';
import SocialLinkRowItemTracking from './Footer/SocialLinkRow/SocialLinkRowItemTracking';
import DisplaySettingsModal from './Footer/DisplaySettingsModal/DisplaySettingsModal';
import FooterSubscribe from './Footer/FooterSubscribe/FooterSubscribe';
import DibsClientRenderer from 'dibs-server-components/exports/DibsClientRenderer';
import { responsiveFooterClientQuery } from './__generated__/responsiveFooterClientQuery.graphql';

// css from server components
import '../components/Footer/Footer-style.scss';
import '../components/Footer/FooterBottomRow.scss';
import '../components/Footer/AppStoreLink/AppStoreLink-style.scss';
import '../components/Footer/ConnectRow/ConnectRow.scss';
import '../components/Footer/SocialLinkRow/SocialLinkRow-style.scss';
import '../components/Footer/AppStoreLink/AppStoreLink-style.scss';
import '../components/Footer/LinkColumn/LinkColumn.scss';
import '../components/Footer/LinkColumn/LinkColumnItem.scss';
import '../components/Footer/GlobalSitesLinks/GlobalSitesLinks.scss';
import 'dibs-elements/exports/Grid';
import 'dibs-elements/exports/Link';

const query = graphql`
    query responsiveFooterClientQuery($userId: String = "", $hasUserId: Boolean!) {
        viewer {
            ...DisplaySettingsModal_viewer
            ...FooterSubscribe_viewer
            user(userId: $userId) @include(if: $hasUserId) {
                ...DisplaySettingsModal_user
            }
        }
    }
`;

type ResposiveFooterRenderArgs = {
    relayEnv: Environment;
    Wrapper: FC;
};

async function getProps({
    relayEnv,
}: {
    relayEnv: Environment;
}): Promise<{
    user: responsiveFooterClientQuery['response']['viewer']['user'] | null;
    viewer: responsiveFooterClientQuery['response']['viewer'] | null;
}> {
    const userId = getBuyerId(document.cookie) || '';
    const hasUserId = !!userId;

    const data = await fetchQuery<responsiveFooterClientQuery>(relayEnv, query, {
        userId,
        hasUserId,
    });

    return {
        user: data?.viewer?.user || null,
        viewer: data?.viewer || null,
    };
}

export async function render({ relayEnv, Wrapper }: ResposiveFooterRenderArgs): Promise<void> {
    const clientRenderer = new DibsClientRenderer({ namespace: 'footer', Wrapper });

    clientRenderer.registerComponent('FooterTrackingWrapper', FooterTrackingWrapper);
    clientRenderer.registerComponent('FooterSeoLinkWrapper', FooterSeoLinkWrapper);
    clientRenderer.registerComponent('SocialLinkRowItemTracking', SocialLinkRowItemTracking);
    clientRenderer.registerComponent('FooterSubscribe', FooterSubscribe);
    clientRenderer.registerComponent('DisplaySettingsModal', DisplaySettingsModal);
    clientRenderer.registerComponent(
        'Contact1stdibsFooterLinkWrapper',
        Contact1stdibsFooterLinkWrapper
    );

    addLoginHandlers(async () => {
        const rerenderProps = await getProps({ relayEnv });
        clientRenderer.rerender({ additionalProps: rerenderProps });
    });

    const additionalProps = await getProps({ relayEnv });
    clientRenderer.render({ additionalProps });
}
